define('tdcheckout', ['jquery'], function ($) {

  var tdcheckout = {
    js_checkoutOptionChange: function js_checkoutOptionChange() {
      var checkBoxAcc = $('#checkout__optionAccount');

      if (!!checkBoxAcc.length) {
        var passFieldsWrapper = $('.checkout__option--account');
        var passwordFields = passFieldsWrapper.find('[type="password"]');
        var optionField = $('[name="order"]:eq(0) [name="option"]');
        var hideClass = 'hide';

        checkBoxAcc.on('change', function (e) {
          if (passFieldsWrapper.hasClass(hideClass)) {
            passFieldsWrapper.slideDown(10, function () {
              passFieldsWrapper.removeClass(hideClass);
              //optionField.val("3");
              passwordFields.attr('required', 'required');
              //wacustomvalidity.invalidFields();
              checkout.method = 'register';
              new Ajax.Request(checkout.saveMethodUrl, { method: 'post', onFailure: checkout.ajaxFailure.bind(checkout), parameters: { method: 'register' } });
            });
          } else {
            passFieldsWrapper.slideUp(10, function () {
              passFieldsWrapper.addClass(hideClass);
              optionField.val("1");
              passwordFields.removeAttr('required');
              //wacustomvalidity.invalidFields();
              checkout.method = 'guest';
              new Ajax.Request(checkout.saveMethodUrl, { method: 'post', onFailure: checkout.ajaxFailure.bind(checkout), parameters: { method: 'guest' } });
            });
          }
        });
      }
    },
    js_checkoutOptions: function js_checkoutOptions() {

      var checkoutHeadline = $(".js_checkoutOptions");
      var activeClassName = "js_current";
      var allOptions = $('.checkout__option');

      checkoutHeadline.on('click', function () {
        if (window.wabreakpoint != 'large') {
          var self = $(this);
          var checkoutOption = self.next();

          if (!checkoutOption.is(':visible')) {
            allOptions.not(checkoutOption).hide().prev().removeClass(activeClassName);

            checkoutOption.show();
            self.addClass(activeClassName);
          } else {
            checkoutOption.hide();
            self.removeClass(activeClassName);
          }
        }
      });
    }
  };

  return tdcheckout;
});

